module.exports = __webpack_public_path__ + "img/icon_condo.9547cd89.svg";